import styles from '../style.postcss';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const TipsAndUpdatesIcon = ({ className, onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    className={classnames(styles.FeedbackSuggestions_tipsIcon, className)}
    aria-hidden="true"
    onClick={onClick}
  >
    <path d="m880-560-25-55-55-25 55-25 25-55 25 55 55 25-55 25-25 55ZM760-720l-38-82-82-38 82-38 38-82 38 82 82 38-82 38-38 82ZM303.5-103.5Q280-127 280-160h160q0 33-23.5 56.5T360-80q-33 0-56.5-23.5ZM200-200v-80h320v80H200Zm10-120q-69-41-109.5-110T60-580q0-125 87.5-212.5T360-880q125 0 212.5 87.5T660-580q0 81-40.5 150T510-320H210Zm24-80h252q45-32 69.5-79T580-580q0-92-64-156t-156-64q-92 0-156 64t-64 156q0 54 24.5 101t69.5 79Zm126 0Z" />
  </svg>
);

TipsAndUpdatesIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default TipsAndUpdatesIcon;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/FeedbackSuggestions/TipsAndUpdatesIcon/index.jsx